import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { Col } from "react-bootstrap";
import { fromOperatorDefault } from "Utils/Constants";
import { clickifyPhoneNumber } from "Utils/Utils";
import Linkify from 'react-linkify';
import Navigation from "./Navigation";
import TermsAndConditions from "Components/TermsAndConditions";
import CancelButton from "Components/CancelButton";

import "react-datepicker/dist/react-datepicker.css";

const EnrollmentStep = ({
  formData,
  setForm,
  fromOperator,
  navProps,
  errorMessage,
  isEnrollment,
  plaidRedirect,
  renderFields,
  showNav = true,
  showTitle = true,
  title = 'Enrollment',
  disabled = false }) => {

  fromOperator = (fromOperator) ? fromOperator : fromOperatorDefault;

  const [validated, setValidated] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  // Dictionary of fieldname : isValid booleans.
  const [fieldIsValid, setFieldIsValid] = useState();
  // Use to override field validation if we're on a page that doesn't show individual fields
  const [isValidOverride, setIsValidOverride] = useState();

  const onFieldChange = (fieldName, fieldValue, isValid) => {
    setForm({
      target: {
        name: fieldName,
        value: fieldValue,
        isValid: isValid
      },
    });
    // We expect each form field to report its own validation status.
    setFieldIsValid(prevState => {
      return { ...prevState, [fieldName]: isValid }
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false || !isFormValid) {
      event.stopPropagation();
    } else {
      navProps.navigation.next();
    }

    setValidated(true);
  };

  const isLastStep = navProps.steps.length === navProps.index + 1;
  const isFormValid = isValidOverride ?? (fieldIsValid && Object.values(fieldIsValid).every(val => val === true));
  const proceed = isFormValid;
  const updatedNavProps = { ...navProps, proceed, formData };

  const fieldProps = { formData, fromOperator, onFieldChange, disabled, setIsValidOverride, isEnrollment, plaidRedirect };

  return (
    <div>
      {showTitle && <div className="sub-title">{title}</div>}
      {errorMessage && <div className="top-error">
        <Linkify componentDecorator={(decoratedHref, decoratedText, key) => (
          <a target="blank" href={decoratedHref} key={key}>
            {decoratedText}
          </a>)}>
          {clickifyPhoneNumber(errorMessage)}
        </Linkify>
      </div>}
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        {renderFields(fieldProps)}
        {showNav && <Navigation {...updatedNavProps} />}
        {isLastStep && <Form.Row>
          <Col className="text-center">
            <TermsAndConditions buttonText="submit" />
          </Col>
        </Form.Row>}
        {/* <Form.Row>
        <Col md={{ span: 6, offset: 3 }}>
            <CancelButton btnText="Account Sign Up" stage="Enrollment"></CancelButton> 
            </Col>
        </Form.Row> */}
      </Form>
      <CancelButton btnText="Account Sign Up" stage="Enrollment"></CancelButton>
    </div>
  );
};

export default EnrollmentStep;
